import React, { useState } from 'react';
import { useI18n } from '../i18n/I18nProvider';
import { useBookersContent } from '../hooks/useBookersContent';
import SignUpLink from './SignUpLink';

export default function Flexibility() {
  const { t } = useI18n();
  const { modules, paymentControls } = useBookersContent();
  const [active, setActive] = useState({ tables: true, experiences: true, events: false });
  const toggle = (k) => setActive((p) => ({ ...p, [k]: !p[k] }));

  return (
    <section className="bg-white">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 section-pad">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <div className="reveal">
            <p className="text-sm font-semibold text-[#76B828]">{t('flexibility.eyebrow')}</p>
            <h2 className="font-display text-4xl md:text-5xl mt-3 text-[#0b0b0f]">{t('flexibility.title')}</h2>
            <p className="text-[#55555f] mt-4 text-lg">{t('flexibility.description')}</p>

            <div className="mt-8 space-y-3">
              {modules.map((m) => {
                const on = active[m.key];
                return (
                  <button
                    key={m.key}
                    type="button"
                    onClick={() => toggle(m.key)}
                    className={`w-full flex items-center gap-4 rounded-2xl border p-4 text-left transition-all ${
                      on ? 'border-[#76B828]/40 bg-[#F4F9E8]' : 'border-black/10 bg-white hover:bg-[#fafafb]'
                    }`}
                  >
                    <span className={`h-11 w-11 rounded-xl flex items-center justify-center transition-colors ${on ? 'bg-[#76B828] text-white' : 'bg-[#EEF6DC] text-[#76B828]'}`}>
                      <m.icon size={20} />
                    </span>
                    <span className="flex-1">
                      <span className="block font-semibold text-[#0b0b0f]">{m.label}</span>
                      <span className="block text-sm text-[#6b6b73]">{m.desc}</span>
                    </span>
                    <span className={`relative h-6 w-11 rounded-full transition-colors ${on ? 'bg-[#76B828]' : 'bg-black/15'}`}>
                      <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-white shadow transition-all ${on ? 'left-[22px]' : 'left-0.5'}`} />
                    </span>
                  </button>
                );
              })}
            </div>
            <p className="text-sm text-[#8b8b95] mt-4">{t('flexibility.modularNote')}</p>
          </div>

          <div className="reveal lg:pt-16">
            <div className="rounded-[2rem] bg-pastel-mint border border-black/5 p-8">
              <p className="text-sm font-semibold text-[#16a34a]">{t('flexibility.paymentEyebrow')}</p>
              <h3 className="font-display text-2xl md:text-3xl mt-2 text-[#0b0b0f]">{t('flexibility.paymentTitle')}</h3>
              <div className="mt-7 space-y-4">
                {paymentControls.map((p) => (
                  <div key={p.title} className="flex gap-4 bg-white/70 rounded-2xl p-4 border border-black/5">
                    <span className="h-11 w-11 shrink-0 rounded-xl bg-white flex items-center justify-center">
                      <p.icon size={20} className="text-[#0b0b0f]" />
                    </span>
                    <div>
                      <p className="font-semibold text-[#0b0b0f]">{p.title}</p>
                      <p className="text-[#5a5a63] text-[14px] mt-1 leading-relaxed">{p.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
              <SignUpLink className="btn-pill btn-dark w-full py-3.5 text-[15px] mt-6 block text-center">
                {t('flexibility.setupPayments')}
              </SignUpLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
